import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NotificacionService } from '@services';
import { Notificacion } from '@models';

@Component({
	selector: 'app-notificaciones',
	templateUrl: './notificaciones.component.html',
	styleUrls: ['./notificaciones.component.css'],
})
export class NotificacionesComponent implements OnInit {
	public notifications: Notificacion[];
	public showNotification: boolean;

	@Output() public setBuscando = new EventEmitter<boolean>();

	constructor(private _notificacionService: NotificacionService) {
		this.getNotificaciones();
	}

	ngOnInit() {}

	getNotificaciones() {
		let notificationsTMP = [];
		this.notifications = [];
		if (!localStorage['notificationsX']) {
			localStorage.setItem('notificationsX', '');
		}

		const localTMP =
			localStorage['notificationsX'] && localStorage['notificationsX'].length > 0
				? JSON.parse(localStorage.getItem('notificationsX'))
				: localStorage['notificationsX'];

		this._notificacionService.getNotificacionesActivas().subscribe(response => {
			if (response.result === 'ok') {
				if (response.data.length > 0) {
					notificationsTMP = response.data;

					notificationsTMP.forEach(element => {
						if (localTMP && localTMP.length > 0) {
							let exist = false;

							localTMP.forEach(not => {
								if (not.id === element.id && not.descripcion === element.descripcion && not.visto) {
									exist = true;
									this.notifications.push(new Notificacion(not));
								} else if (not.id === element.id && not.descripcion !== element.descripcion) {
									exist = true;
									element.visto = false;
									this.notifications.push(new Notificacion(element));
								}
							});
							if (!exist) {
								this.notifications.push(new Notificacion(element));
							}
						} else {
							this.notifications.push(new Notificacion(element));
						}
					});
					localStorage['notificationsX'] = JSON.stringify(this.notifications);
					this.showNotification = true;
				}
			}
			this.setBuscando.emit(true);
		});
	}

	notifClose(event) {
		this.notifications[event].visto = true;
		localStorage['notificationsX'] = JSON.stringify(this.notifications);
	}
}
